// src/belediye/components/authz/ModuleGate.js
//
// FAZ-52 — MODÜL KAPISI (rota seviyesi).
//
// Kullanıcı kararı (2026-07-27): "görev modülü veya sohbet modülü adminden
// kapatılırsa bununla ilgili TÜM yapı frontend'den kapatılacak; veriler
// silinmeyecek, sadece yapı kapatılacak."
//
// Bugüne kadar modül kapatınca yalnız SIDEBAR maddeleri gizleniyordu; rota
// hâlâ açıktı. Adres çubuğuna /yonetim/gorevler yazan (ya da eski bir yer imi
// olan) kullanıcı boş/kırık bir sayfa görüyordu: uçlar ModuleGateMiddleware
// yüzünden 404 dönüyor, sayfa da "veri yok" diye açılıyordu.
//
// Artık modül kapalıysa rota da kapanır → kullanıcı dashboard'a döner.
//
// Not: bu bir GÜVENLİK sınırı DEĞİL (gerçek kapı backend'de). Amaç, kapalı bir
// modülün arayüzde iz bırakmaması.

import { Navigate } from "react-router-dom";

import useModuleEnabled from "../../hooks/useModuleEnabled";

export default function ModuleGate({ module, children, to = "/yonetim/dashboard" }) {
  const acik = useModuleEnabled(module);
  if (!acik) return <Navigate to={to} replace />;
  return children;
}
